import * as React from 'react';
import * as _ from 'lodash/fp';
import { FormControl, MenuItem, Select as MaterialSelect,  } from '@mui/material';
import styled from 'styled-components';
import { getColor, getFontSize, getShadow } from '@process-advisor/process-miner/shared/theme';
import CheckIcon from '@process-advisor/assets/checkIcon.png'

const Select = styled(MaterialSelect)`
    color: ${getColor('inputTextColor')};
    font-size: ${getFontSize('smaller')};
    height: 30px;
    min-width: 90px;
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;

    .MuiSelect-select,
    .MuiSelect-outlined,
    .MuiInputBase-input,
    [class*="MuiSelect-select"] {
        min-height: 18px !important;
        height: 18px !important;
        padding: 5px 32px 5px 10px !important;
        display: flex !important;
        align-items: center !important;
        font-size: ${getFontSize('smaller')} !important;
        line-height: 18px !important;
        color: ${getColor('inputTextColor')} !important;
        background: transparent !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .MuiSelect-select:focus,
    .MuiSelect-outlined:focus,
    .MuiInputBase-input:focus,
    [class*="MuiSelect-select"]:focus {
        background: transparent !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .MuiOutlinedInput-notchedOutline {
        border: 1px solid #DFE1E6 !important;
        border-radius: 8px !important;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline,
    &:hover .MuiOutlinedInput-notchedOutline {
        border-color: #4C9AFF !important;
        border-width: 1px !important;
    }

    .MuiSvgIcon-root {
        right: 7px;
        color: #172B4D;
        font-size: 18px;
    }

    & .MuiMenu-paper {
        border-radius: 10px;
        margin-top: 6px;
        box-shadow: ${getShadow('menu')};
        border: .5px solid ${getColor('borderColor')};
    }

    & .MuiMenuItem-root {
        font-size: ${getFontSize('smaller')};
        color: ${getColor('darkFontColor')};
        padding: 5px 8px;
        display: flex;
        justify-content: space-between;
    }

    & .Mui-selected img {
        display: block;
    }

    & legend {
        width: 0 !important;
        border-bottom: none !important;
    }
`;

const Check = styled.img`
    width: 10px;
    height: 10px;
    display: none;
`;

const Label = styled.div`
    margin-right: 15px;
    font-size: ${getFontSize('smaller')};
    color: ${getColor('darkFontColor')};
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    max-width: 100%;
`;

type Option = {
    value: string | number;
    label: string;
}

type Props = {
    options: Option[];
    value: string | number;
    onChange: (value: string | number) => void;
    className?: string;
    label?: string;
}

export const Dropdown: React.FC<Props> = ({
    options,
    value,
    onChange,
    className,
    label,
}) => {
    const handleOnChange = (event) => {
        onChange(event.target.value);
    };

    const isProperValue = () => _.some<Option>((option) => option.value === value)(options);

    return (
        <Wrapper>
            { label && <Label>{label}</Label>}
            <FormControl
                className={className}
                appearance="default"
                size="small"
                sx={{ minWidth: 90, width: '100%' }}>
                <Select
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        disablePortal: true,
                    }}
                    value={isProperValue() ? value : ''}
                    onChange={handleOnChange}>
                    {
                        _.map(({ value: optionValue, label }) => (
                            <MenuItem
                                key={optionValue}
                                value={optionValue}>
                                {label}
                                <Check
                                    src={CheckIcon}
                                    alt="check" />
                            </MenuItem>
                        ))(options)
                    }
                </Select>
            </FormControl>
        </Wrapper>
    );
};
